import React from 'react';
import {ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from '../theme';
import PublicSite from './PublicSite';
export default function PublicRoot() {
  return <ThemeProvider theme={theme}><CssBaseline/><PublicSite/></ThemeProvider>;
}
